import { ERROR } from "constant/message";
import { dateFormatFull } from "utils/dateFormat";
import { searchUser } from "./userService";

const getMouvement = async (ApiService, idAnimal) => {
  const fetchData = await ApiService.getData(`animals/${idAnimal}/movements`);
  let result = [];
  if (fetchData !== ERROR) {
    result = await Promise.all(
      fetchData.map(async (i) => {
        let motif = "";
        if (i.fieldName === "Eleveur") {
          motif = "Changement d'éleveur";
        } else if (i.fieldName === "Proprietaire" || i.fieldName === "Properietaire") {
          motif = "Changement de propriétaire";
        } else if (i.fieldName === "Ferme") {
          // motif = "Changement d'exploitation";
          motif = "Changement de ferme";
        } else if (i.fieldName === "Agent") {
          motif = "Changement d'agent Identificateur";
        } else if (i.fieldName === "Puce") {
          motif = "Changement de puce";
        } else if (i.fieldName === "RefAnimal") {
          motif = "Changement de référence de l'animal";
        }
        let { previousValue, currentValue } = i;

        if (
          i.fieldName === "Eleveur" ||
          i.fieldName === "Proprietaire" ||
          i.fieldName === "Properietaire"
        ) {
          let previous = [];
          let current = [];
          if (i.previousValue === null) {
            previousValue = "";
          } else {
            previous = await searchUser(ApiService.postData, i.previousValue);

            if (Array.isArray(previous) && previous.length > 0) {
              previousValue = `${previous[0]?.prenom} ${previous[0]?.nom}`;
            }
          }
          if (i.currentValue === null) {
            currentValue = "";
          } else {
            current = await searchUser(ApiService.postData, i.currentValue);
            if (Array.isArray(current) && current.length > 0) {
              currentValue = `${current[0]?.prenom} ${current[0]?.nom}`;
            }
          }
        }
        let dateMouvement = i.timestamp;
        if (i?.timestamp === null) {
          dateMouvement = "";
        } else {
          dateMouvement = dateFormatFull(new Date(i?.timestamp));
        }

        const item = {
          ...i,
          ...{ motif, previousValue, currentValue, dateMouvement },
        };
        return item;
      })
    );
  }
  return result;
};
export default getMouvement;
export const getLogByFieldValue = async (ApiService, fieldName, fieldValue) => {
  const fetchData = await ApiService.getData(
    `logs/field?fieldName=${fieldName}&value=${fieldValue}`
  );
  let result = [];
  if (fetchData !== ERROR) {
    result = await Promise.all(
      fetchData.map(async (i) => {
        let motif = "";
        if (i.previousValue === fieldValue) {
          motif = "Retrait";
        } else if (i.currentValue === fieldValue) {
          motif = "Assignation";
        }
        let dateMouvement = "";
        if (i?.timestamp !== null) {
          dateMouvement = dateFormatFull(new Date(i?.timestamp));
        }
        const auteur = `${i?.prenom ?? ""} ${i?.updatedBy ?? ""} - ${i?.numTel ?? ""}`;

        const item = {
          ...i,
          motif,
          dateMouvement,
          auteur,
        };
        return item;
      })
    );
  }
  return result;
};
